import {defineStore} from 'pinia';
import Network from "~/utils/network";

const urls = {
    startPayment:  `/bnpl/transaction/start`,
    startPaymentWithAmount: `/bnpl/my-deal/partial`,
    isPartialAvailable: `/bnpl/my-deal/partial-available`,
    getStatus: (publicId) => `/bnpl/transaction/${publicId}/status`,
    payNow: `/bnpl/my-deal/pay-in-full`,
}

export const usePaymentStore = defineStore('payment', {
    state: () => ({}),
    actions: {
        startPayment: async function (publicId, withModify) {
            try {
                return await Network.http(urls.startPayment, {method: 'POST', body: {publicId: publicId, changePaymentInfo: withModify}});
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
        startPaymentWithAmount: async function (transactionId, amount, changePaymentInfo) {
            try {
                return await Network.http(urls.startPaymentWithAmount, {method: 'POST', body: {
                    transactionId,
                    amount,
                    changePaymentInfo,
                }});
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
        fetchIsPartialAvailable: async function (transactionId, amount) {
            try {
                return await Network.http(urls.isPartialAvailable, {method: 'POST', body: {
                    transactionId,
                    amount,
                }});
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
        getStatus: async function (publicId) {
            try {
                return await Network.http(urls.getStatus(publicId))
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
        async startPayNow(publicId, changePaymentInfo = true) {
            try {
                return await Network.http(urls.payNow, {method: 'POST', body: {publicId: publicId, changePaymentInfo: changePaymentInfo}});
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
    },
});
